module.exports = {
  groupBy: function (objectArray) {
    const property = 'lema';
    let groupedData = objectArray.reduce(function (acc, obj) {
      let key = obj[property];
      if (!acc[key]) {
        acc[key] = {
          lema: obj['lema'],
          examples: obj['examples'].split('<br>'),
          freq: obj['freq'],
          main_word: obj['main_word'],
          sr: obj['sr'],
          main_word_pos: obj['main_word_pos'],
          word_count: obj['word_count'],
          grammar_variants: obj['grammar_variants'],
          word_order_changeable: obj['word_order_changeable'] ? 'keičiasi' : 'nesikeičia',
          arbitral: obj['arbitral'] === true ? 'Taip' : obj['arbitral'] === false ? 'Ne' : '',
          forms: [],
        };
      }
      acc[key]['forms'].push({
        form: obj['form'],
        form_freq: obj['form_freq'],
        insertion: obj['insertion'],
        grammar: obj['grammar'],
      });
      return acc;
    }, {});
    return Object.values(groupedData);
  },
};

